import React from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import "./../subscribeForm/subscribeForm.scss";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { FormattedMessage, useIntl } from "react-intl";
import ChevronIcon from "svg-icons/chevron-icon.js";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang.js";
import {
  formOfDataRequested,
  purposeOfRequestingDataList,
} from "constants/Defaults.js";
import { useDispatch, useSelector } from "react-redux";
import DataRequestItemForm from "./data-request-form-item";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import { END_POINTS } from "constants/APIConstant";
import useSWR from "swr";
import MainDepartment from "component/shared/main-department/MainDepartment";
import HtmlView from "component/htmlView/html-view";
import AboutDepartment from "component/shared/about-department/AboutDepartment";
import fetch from "auth/FetchInterceptor";
import { apiResponseMessage } from "redux/actions/ApiMessageResponse";
import { MESSAGE_TYPE } from "redux/constants/ApiMessageResponse";
import ReactGA from "react-ga4";

function DataRequest() {
  const intl = useIntl();

  const dir = useSelector(({ theme }) => theme.direction);
  const userInfo = useSelector(({ auth }) => auth);  
  const dispatch = useDispatch();
  const currentLocale = useSelector(({ theme }) => theme.locale);

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

      
  ReactGA.initialize(END_POINTS.TRACKING_ID)

  React.useEffect(() => {
      // Send pageview with a custom path
      ReactGA.send({ hitType: "pageview", page: "/datarequest", title: "DataRequest Page" });
  }, []);


  const formSchema = Yup.object().shape({
    requiredInformation: Yup.string().required(),
    employeer: Yup.string().required(),
  });
  const formOptions = {
    resolver: yupResolver(formSchema),
    defaultValues: {
      purposeOfRequestingData: "0",
      formOfDataRequested: "1",
    },
  };
  const { control, register, handleSubmit, reset, formState } =
    useForm(formOptions);
  const { errors } = formState;

  const [data, setData] = useState("");

  async function postDataRequest(data) {
    var DataRequestData = {
      requiredInformation: data.requiredInformation,
      employeer: data.employeer,
      // requiredInformation: data.requiredInformation,
      purposeOfRequestingData: parseInt(data.purposeOfRequestingData),
      formOfDataRequested: parseInt(data.formOfDataRequested),
      isPublished: true,
      status: 3,
      //userId: data.userId, //how get the userId + not in db
    };
    return await fetch.post(END_POINTS.DATA_REQUEST, DataRequestData);
  }
  const onSubmit = async (data) => {
    try {
      var result = await postDataRequest(data);
      if (result?.state) {
        dispatch(
          apiResponseMessage({
            showMessage: true,
            message: <FormattedMessage id="sent-successfully" />,
            messageType: MESSAGE_TYPE.SUCCESS,
          })
        );
      } else {
        dispatch(
          apiResponseMessage({
            showMessage: true,
            message: result?.data?.message ? (
              result?.data?.message
            ) : (
              <FormattedMessage id="timeout-error" />
            ),
            messageType: MESSAGE_TYPE.ERROR,
          })
        );
      }
    } catch (error) {
      dispatch(
        apiResponseMessage({
          showMessage: true,
          message: error?.response?.data?.message ? (
            error?.response?.data?.message
          ) : (
            <FormattedMessage id="timeout-error" />
          ),
          messageType: MESSAGE_TYPE.ERROR,
        })
      );
    }
  };

  const getServices = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS}/${END_POINTS.DATA_REQUEST_DEPARTMENT_ID}`,
  });

  const getDepartment = useSWR({
    url: `${END_POINTS.SERVICES_TOOLS_DEPARTMENT}=${END_POINTS.DATA_REQUEST_DEPARTMENT_ID}`,
  });

  return (
    <ContentLoading
      isLoading={getDepartment.isLoading || getServices.isLoading}
    >
      <div className="data-request">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "service-tools" }),
              clickClass: false,
            },
            {
              title: intl.formatMessage({ id: "data-request" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "data-request-service" })}
          route={"../servicestools"}
        />
        <div className="container py-5">
          <div className="row">
            <div className="col-12 col-lg-8">
              <div className="m__title">
                <h3>
                  <FormattedMessage id="datarequest" />
                </h3>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                {/* <div className="form-label row">
                  <div className="col-lg-4">
                <label><FormattedMessage id="fname"/>:</label>
                </div>
                <div className="form-label-container">
                  <input type="text" {...register("firstName")}/>
                  <span>*</span>
                </div>
              </div>
              <div className="form-label row">
                  <div className="col-lg-4">
                <label><FormattedMessage id="lname"/>:</label>
                </div>
                <div className="col-lg-8">
                <div className="form-label-container">
                  <input type="text" {...register("lastName")}/>
                  <span>*</span>
                </div>
                </div>
              </div> */}
                <DataRequestItemForm
                  label={intl.formatMessage({ id: "firstName" })}
                  isOptional={true}
                >
                  <input
                    type="text"
                    disabled
                    value={userInfo.firstName}
                    className={"form-control"}
                  />
                </DataRequestItemForm>
                <DataRequestItemForm
                  label={intl.formatMessage({ id: "lastName" })}
                  isOptional={true}
                >
                  <input
                    type="text"
                    disabled
                    value={userInfo.lastName}
                    className={"form-control"}
                  />
                </DataRequestItemForm>

                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="employer" />
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div className="form-label-container">
                      <input
                        type="text"
                        {...register("employeer")}
                        className={`form-control ${
                          errors.employeer ? "is-invalid" : ""
                        }`}
                      />
                      <span>*</span>
                    </div>
                  </div>
                </div>
                <DataRequestItemForm
                  label={intl.formatMessage({ id: "email" })}
                  isOptional={true}
                >
                  <input
                    type="text"
                    disabled
                    value={userInfo.email}
                    className={"form-control"}
                  />
                </DataRequestItemForm>
                <DataRequestItemForm
                  label={intl.formatMessage({ id: "phoneNumber" })}
                  isOptional={true}
                >
                  <input
                    type="text"
                    disabled
                    value={userInfo.phoneNumber}
                    className={"form-control"}
                  />
                </DataRequestItemForm>
                {/* <div className="form-label row">
                  <div className="col-lg-4">
                <label> <FormattedMessage id="email"/>:</label>
                </div>
                <div className="col-lg-8">
                <div className="form-label-container">
                  <input type="text" {...register("email")}/>
                  <span>*</span>
                </div>
                </div>
              </div>

              <div className="form-label row">
                  <div className="col-lg-4">
                <label> <FormattedMessage id="mobile"/>:</label>
                </div>
                <div className="col-lg-8">
                <div className="form-label-container">
                  <input type="text" {...register("mobile")} />
                  <span>*</span>
                </div>
                </div>
              </div>

              <div className="form-label row">
                  <div className="col-lg-4">
                <label> <FormattedMessage id="Address"/>:</label>
                </div>
                <div className="col-lg-8">
                <div className="form-label-container">
                  <input type="text" {...register("address")}/>
                  <span>*</span>
                </div>
                </div>
              </div> */}
                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="required-info" />
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div className="form-label-container">
                      <textarea
                        name=""
                        id=""
                        cols="30"
                        rows="10"
                        {...register("requiredInformation")}
                        className={`form-control ${
                          errors.requiredInformation ? "is-invalid" : ""
                        }`}
                      ></textarea>
                      <span>*</span>
                    </div>
                  </div>
                </div>

                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="data-requested" />
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div className="dropdown">
                      <select
                        className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
                        {...register("formOfDataRequested")}
                      >
                        {formOfDataRequested.map(
                          ({ id, name, Translation }, i) => (
                            <option
                              key={i}
                              value={id}
                              title={LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: name,
                                translations: Translation,
                              })}
                            >
                              <LabelLang
                                id={"name"}
                                defaultValue={name}
                                translations={Translation} //Until translations are made
                              />
                            </option>
                          )
                        )}
                      </select>
                      <span>*</span>
                    </div>
                  </div>
                </div>

                <div className="form-label row">
                  <div className="col-lg-4">
                    <label>
                      <FormattedMessage id="purpose" />
                    </label>
                  </div>
                  <div className="col-lg-8">
                    <div className="dropdown">
                      <select
                        className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
                        {...register("purposeOfRequestingData")}
                      >
                        {purposeOfRequestingDataList.map(
                          ({ id, name, Translation }, i) => (
                            <option
                              key={i}
                              value={id}
                              title={LabelLangString({
                                id: "name",
                                currentLocale: currentLocale,
                                defaultValue: name,
                                translations: Translation,
                              })}
                            >
                              <LabelLang
                                id={"name"}
                                defaultValue={name}
                                translations={Translation} //Until translations are made
                              />
                            </option>
                          )
                        )}
                      </select>
                      <span>*</span>
                    </div>
                  </div>
                </div>
                <div className="row-r mt-4">
                  <button className="main-btn" type="submit">
                    <span>
                      <FormattedMessage id="send" />
                    </span>
                    <ChevronIcon width={12} height={12} color="#FFFFFF" />
                  </button>
                </div>
              </form>
            </div>
            <div className="col-12 col-lg-4">
              <AboutDepartment
                id={"about"}
                txt={getServices?.data?.data?.about}
                translations={
                  getServices?.data?.data?.serviceAndToolTranslation
                }
              />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-12 col-lg-8">
              <div className="calnd-info">
                {getServices?.data?.data?.content !== null &&
                getServices?.data?.data?.content !== undefined ? (
                  <HtmlView
                    html={LabelLangString({
                      id: "content",
                      currentLocale: currentLocale,
                      defaultValue: getServices?.data?.data?.content,
                      translations:
                        getServices?.data?.data?.serviceAndToolTranslation,
                    })}
                  />
                ) : (
                  <FormattedMessage id="data-not-found" />
                )}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <MainDepartment getDepartment={getDepartment} />
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default DataRequest;
